module.exports = __webpack_public_path__ + "static/media/resource-error-notification-icon.7c93679d.svg";